// src/Router/routes.js
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PageTransitionWrapper from "../components/UI/PageTransitionWrapper";

// Components
import HomeSections from "../components/Home/HomeSections";
import GenAi from "../components/Services/Gen-ai";
import MobileAppDevelopment from "../components/Services/Mobile-app-development";
import WebDevelopment from "../components/Services/Web-development";
import DevopsConsulting from "../components/Services/Devops-consulting";
import SalesForceServices from "../components/Services/SalesForceServices";
import Contact from "../components/Home/Contact";
import AboutUs from "../components/Home/AboutUs";
import Location from "../components/Location";
import Company from "../components/AboutUs/Company";
import TeamSection from "../components/AboutUs/TeamSection";
import OurCompanyShowcase from "../components/Home/OurCompanyShowCase";

const AppRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransitionWrapper><HomeSections /></PageTransitionWrapper>} />
        <Route path="/ContactUs" element={<PageTransitionWrapper><Contact /></PageTransitionWrapper>} />
        <Route path="/Services" element={<PageTransitionWrapper><GenAi /></PageTransitionWrapper>} />
        <Route path="/services/gen-ai/" element={<PageTransitionWrapper><GenAi /></PageTransitionWrapper>} />
        <Route path="/services/mobile-app-development" element={<PageTransitionWrapper><MobileAppDevelopment /></PageTransitionWrapper>} />
        <Route path="/services/web-development" element={<PageTransitionWrapper><WebDevelopment /></PageTransitionWrapper>} />
        <Route path="/services/devops-consulting" element={<PageTransitionWrapper><DevopsConsulting /></PageTransitionWrapper>} />
        <Route path="/services/Salesforce-services" element={<PageTransitionWrapper><SalesForceServices /></PageTransitionWrapper>} />
        <Route path="/AboutUs" element={<PageTransitionWrapper><AboutUs /></PageTransitionWrapper>} />
        {/* <Route path="/Location" element={<PageTransitionWrapper><Location /></PageTransitionWrapper>} /> */}
        <Route path="/AboutUs/Company" element={<PageTransitionWrapper><Company /></PageTransitionWrapper>} />
        <Route path="/AboutUs/TeamSection" element={<PageTransitionWrapper><TeamSection /></PageTransitionWrapper>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AppRoutes;
